export const emailAttachmentStyle = {
  attachment: {
    border: "1px solid #d9d9d9",
    padding: ".5rem",
  },
  iconButton: {
    padding: "0px",
  },
  loading: {
    margin: "0 auto",
  },
};
